import { useState } from "react";

const text = `Dr. Evelyn Sterling's textbook is nothing short of a masterpiece in the realm of organic chemistry education. As a student grappling with the complexities of organic molecules and reactions, I found solace in the clear and concise explanations provided throughout the book. Dr. Sterling's extensive experience in academia and research shines through in it.`;
const content = `While the practice problems at the end of each chapter are beneficial, there is room for improvement in terms of diversity and difficulty level. Including a wider range of problems, including both conceptual and numerical ones, would better prepare students for the challenges they may encounter in exa.`;
export const Reviews = () => {
  const [isTextExpended, setisTextExpended] = useState(false);
  const [isContentExpended, setIsContentExpended] = useState(false);

  const toggleTextReadMore = () => setisTextExpended((prevState) => !prevState);
  const toggleContentReadMore = () =>
    setIsContentExpended((prevState) => !prevState);

  return (
    <div className="d-flex gap-3 w-71">
      <div className="d-flex flex-column gap-2 w-100">
        <div className="d-flex justify-content-between w-100">
          <h3 className="text-dark-grey fs-20 fw-500 ls-06 lh-normal">
            Reviews Tab details
          </h3>
          <img
            src="/assets/images/flag.svg"
            alt="report icon here"
            width={22}
            height={22}
          />
        </div>
        <div className="d-flex">
          <p
            className={`review_content ls-48 mb-0 ${
              isTextExpended ? "expanded" : "collapsed"
            }`}
          >
            {isTextExpended ? text : `${text.slice(0, 260)}...`} {"  "}
            <span
              className={isTextExpended ? "read-more" : "read-less"}
              onClick={toggleTextReadMore}
            >
              {isTextExpended ? "Read Less" : " Read More"}
            </span>
          </p>
        </div>

        <div className="d-flex gap-3">
          <div className="d-flex text-green fw-semibold ls-14 text-uppercase w-30">
            Private Feedback
          </div>
          <div className="d-flex">
            <p
              className={`review_content ${
                isContentExpended ? "expanded" : "collapsed"
              } ls-48 mb-0`}
            >
              {isContentExpended ? text : `${content.slice(0, 210)}...`} {"  "}
              <span
                className={isContentExpended ? "read-more" : "read-less"}
                onClick={toggleContentReadMore}
              >
                {isContentExpended ? "Read Less" : " Read More"}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
